const formatNumber = (num: number) => {
  let formatter = new Intl.NumberFormat("en-GB");
  return formatter.format(num);
};

export default formatNumber;
